import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { ExamService } from '../_services/exam.service';
import { AlertifyService } from '../_services/alertify.service';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ExamToPresent } from '../_models/ExamToPresent';

@Injectable()
export class ExamToPresentDetailResolver implements Resolve<ExamToPresent> {
    constructor(private examService: ExamService, private router: Router, private alertify: AlertifyService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<ExamToPresent> {
        return this.examService.getExamToPresent(route.params['id']).pipe(
            catchError(error => {
                this.alertify.error('problem retriving your data');
                this.router.navigate(['/myExams']);
                return of(null);
            })
        );
    }
}